const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaVeiculo: [],
    listaManutencaoArea: [],
    listaUnidade: [],
    listaSugestao: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'MANUTENCAO_ITEM_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'MANUTENCAO_ITEM_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'MANUTENCAO_ITEM_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
            };
        
        case 'MANUTENCAO_ITEM_AREA_SELECT_LISTADO':
			return { ...state, listaManutencaoArea: action.payload.data };

        case 'MANUTENCAO_ITEM_UNIDADE_SELECT_LISTADO':
			return { ...state, listaUnidade: action.payload.data };

        case 'MANUTENCAO_ITEM_SUGESTAO_LISTADO':
			return {
				...state,
				listaSugestao: action.payload.data
            };

        default:
            return state;
    }
}
